module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAPCAYAAAAlH6X5AAAAAXNSR0IArs4c6QAAABBJREFUGFdj+P///38GqhAAwfk7xV355k8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/input_icon.png
// module id = O7R6
// module chunks = 1